import { ConfirmDialog } from '../lib/dialogs/confirm.dialog';
import { PromptDialog, PromptDialogConfig, PromptDialogResult } from '../lib/dialogs/prompt.dialog';
import { MatDialog } from '@angular/material/dialog';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SecurityTask } from '@newgenus/common';

@Injectable({
    providedIn: 'root',
})
export class DialogService {
    private dialog = inject(MatDialog);

    /**
     * Opens a confirm dialog with the given title and description.
     *
     * @param {string} [title="Delete this thing?"] Should be short and to the point.
     * @param {string} [description="This action cannot be undone."] Should be a concise and clear explanation of the consequences of the action.
     * @return {Promise<boolean>} A promise that resolves to true if the user confirms the action, false otherwise.
     */
    public asyncConfirm(title = 'Delete this thing?', description = 'This action cannot be undone.'): Promise<boolean> {
        return firstValueFrom(
            this.dialog
                .open(ConfirmDialog, {
                    data: {
                        title: title,
                        description: description,
                        confirmResultData: true,
                    },
                })
                .afterClosed()
        );
    }

    /**
     * Opens a prompt dialog with an input field.
     *
     * @param {PromptDialogConfig} config Configuration for the prompt dialog
     * @return {Promise<PromptDialogResult>} A promise with confirmed status and input value
     */
    public asyncPrompt(config: PromptDialogConfig): Promise<PromptDialogResult> {
        return firstValueFrom(
            this.dialog
                .open(PromptDialog, {
                    data: config,
                })
                .afterClosed()
        );
    }
}
